import React, { useState } from 'react';
import AxiosPageReadyWrapper from 'components/AxiosPageReadyWrapper';
import api from 'constants/api';
import { submissionStatuses } from 'constants/submissionStatuses';
import { getUserFormSubmissionsQuery } from './query';
import SubmissionDetails from './components/SubmissionDetails';

const DeclinedSubmissions = ({ updateDeclinedSubmissions }) => {
  const [submissions, setSubmissions] = useState([]);

  const getSubmissions = (data) => {
    const {
      data: {
        data: { user_form_submissions = { data: [] } },
      },
    } = data;

    setSubmissions(user_form_submissions.data);
    updateDeclinedSubmissions(user_form_submissions);
  };

  return (
    <AxiosPageReadyWrapper
      method="post"
      url={api.graphql()}
      postBody={{
        query: getUserFormSubmissionsQuery(20, true, [
          submissionStatuses.DECLINED,
          submissionStatuses.DECLINED_AUTHENTICITY,
          submissionStatuses.DECLINED_BRAND,
          submissionStatuses.DECLINED_CONDITION,
        ]),
      }}
      onData={getSubmissions}>
      {submissions.length > 0 && (
        <SubmissionDetails submissions={submissions} />
      )}
    </AxiosPageReadyWrapper>
  );
};

export default DeclinedSubmissions;
